<template>
	<div class="btn-toolbar pull-right" role="toolbar">
		<div class="btn-group form-inline" role="group" aria-label="...">
			<div class="input-group">
				<span class="input-group-addon">
					<input type="checkbox" v-model="filter.allowDate">
				</span>
				<input type="text" class="form-control" :class="{ disabled: !filter.allowDate }" id="daterange">
			</div>
		</div>
		<div class="btn-group form-inline">
			<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
		</div>
		<div class="btn-group" role="group" aria-label="...">
			<button
				title="Filtrar"
				ref="btnfilter"
				@click="doFilter()"
				data-style="slide-left"
				class="btn btn-default">
				<i class="fa fa-search" aria-hidden="true"></i>
			</button>
			<button
				title="Restablecer"
				ref="btnreset"
				@click="reset()"
				data-style="slide-left"
				class="btn btn-default">
				<i class="fa fa-refresh" aria-hidden="true"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'customer'],
		components: {

		},
		data () {
			return {
				filter: {
					date: null,
					allowDate: false,
					text: null,
					customer_id: null,
				}
			}
		},
		mounted() {
			this.initDate()
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				if(this.customer) {
					this.filter.customer_id = this.customer.id
				}
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(this.filter.allowDate) {
					this.filter.date = $('#daterange').val()
				} else {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.data = false
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			initDate() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/agreements/views/FilterBar.vue